/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Collapse, Drawer, Grid, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {Close, LocalOffer, Menu, Search} from '@mui/icons-material'
import {useContext, useEffect, useState} from "react";
import {REDESCLARAS, SECCIONES} from "../../Constantes";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {useNavigate} from "react-router";
import {irUrl} from "../../Utilidades/irUrl";
import {contexApp} from "../../App";

const BarraCell = ({negro}) => {
    const cData = useContext(contexApp)
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [palabra, setPalabra] = useState('')
    const [subCategorias, setSubCategorias] = useState([])
    const [openSubCats, setOpenSubCats] = useState(false)

    const sePresiono = (e) => {

        if (e.key === 'Enter') {
            setOpen(false)
            navigate('/Resultados/palabra/' + palabra)
        }
    }


    const irRuta = (ruta) => {

        if (ruta === SECCIONES[0]) {
            navigate(`/Home`)
            setTimeout(() => {
                scrolearAComponente(SECCIONES[0])
            }, 500)

        } else {
            navigate(`/${ruta}`)
        }
    }

    useEffect(() => {

        if (cData.subCategorias) {
            setSubCategorias(cData.subCategorias)
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: negro ? '#000' : '#00000000', px: 3, py: 3}}
        >

            <img
                onClick={() => navigate('/Home')}
                src={logo} width={130} height={'auto'} style={{marginTop: -5}}/>

            <IconButton
                onClick={() => setOpen(true)}
            >
                <Menu sx={{fill: '#fff'}}/>
            </IconButton>

            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>


                    <TextField
                        label={'Búsqueda por producto'}
                        fullWidth={false}
                        size={'small'}
                        variant={'outlined'}
                        color={'action'}
                        focused
                        value={palabra}
                        onChange={e => setPalabra(e.target.value)}
                        onKeyDown={(e) => sePresiono(e)}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Search
                                            onClick={() => {
                                                setOpen(false)
                                                navigate('/Resultados/palabra/' + palabra)
                                            }}
                                            sx={{fill: '#ffffff90', cursor: 'pointer'}}/>
                                    </InputAdornment>
                                ),
                                disableUnderline: true,
                                sx: {color: '#fff'}
                            },
                            inputLabel: {
                                sx: {marginLeft: -1, color: '#fff'}
                            }
                        }

                        }
                        sx={{mb: 2}}
                    />

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    irRuta('Home')
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    textAlign: 'center'
                                }}>HOME</Typography>
                        </ButtonBase>
                    </Grid>

                    <Grid container size={{xs: 12, ms: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpenSubCats(!openSubCats)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>CATEGORÍAS</Typography>
                            </ButtonBase>

                            <Collapse in={openSubCats}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{py: 3}}
                                >

                                    {subCategorias.map((it, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center', marginTop: 2}}>
                                                <ButtonBase
                                                    onClick={() => {
                                                        setOpen(false)
                                                        setTimeout(() => {
                                                            navigate('/Resultados/subCat/' + it.nombre)
                                                        }, 800)

                                                    }
                                                    }

                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#fff',
                                                            fontSize: 20,
                                                            fontWeight: 600,
                                                            textAlign: 'center'
                                                        }}>{it.nombre}</Typography>
                                                </ButtonBase>
                                            </Grid>
                                        )
                                    })}


                                </Grid>
                            </Collapse>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        irRuta('COLECCIONES')
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>COLECCIONES</Typography>
                            </ButtonBase>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        irRuta('Nosotras')
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>NOSOTRAS</Typography>
                            </ButtonBase>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        navigate('/Todos')
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>TODOS LOS PRODUCTOS</Typography>
                            </ButtonBase>
                        </Grid>


                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    navigate('/Descuentos')
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    textAlign: 'center'
                                }}>
                                <span><LocalOffer sx={{mt: 0, mb: -0.7, pr: 0.7, width: 24, height: 24}}/></span>
                                SALE
                            </Typography>
                        </ButtonBase>
                    </Grid>

                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 50}}>
                        <img src={logo} width={150} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 2}}>
                        {REDESCLARAS.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <img src={item.icono} width={32} height={'auto'}/>
                                    </IconButton>
                                </Grid>
                            )
                        })}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell